import { c as _c } from "react/compiler-runtime";
import { DropdownMenuItem } from '@pc/components/ui/dropdown-menu';
import { useContext } from 'react';
import MenuContext from './MenuContext';
import { menuSvg } from './menuSvg';
const myMenuConfig = [{
  title: '로그아웃',
  img: 'MyMenuLogout',
  url: ''
}];
export function MyInfoMenu() {
  const $ = _c(4);
  const {
    navigateHandler
  } = useContext(MenuContext);
  let t0;
  if ($[0] !== navigateHandler) {
    t0 = myMenuConfig.map((el, i) => <div className="item" key={i}><DropdownMenuItem className="text-box" onClick={() => navigateHandler(el)}><div className="w-5 ">{menuSvg[el.img]}</div><div className="text-colorFg01">{el.title}</div></DropdownMenuItem></div>);
    $[0] = navigateHandler;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <div className="all-menu-container"><div className="list">{t0}</div></div>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}